module.exports = "/_next/static/images/e890a3fada0e9429708d88b997a86a4e-card-background-right-xs.jpg.webp";